module.exports = __webpack_public_path__ + "static/media/left-img.af64cd11.png";